import { ApolloClient, gql, InMemoryCache } from '@apollo/client';

const myUpsellListContacts = gql`
    query myUpsellListContacts($upsellList: Int!) {
        myUpsellListContacts(upsellList: $upsellList) {
            id
            customer {
                firstname
                lastname
                phone
                customer {
                    email
                }
            }
            assignedContact {
                id
                call_state {
                    name
                }
                talk_state {
                    name
                }
            }
            comment
            deleted
            created_at
        }
    }
`;

export interface UpsellListContact {
    id: number;
    customer: {
        firstname: string;
        lastname: string;
        phone: string;
        customer: {
            email: string;
        };
    };
    assignedContact: {
        id: number;
        call_state: {
            name: string;
        };
        talk_state: {
            name: string;
        };
    };
    comment: string;
    deleted: boolean;
    created_at: string;
}

const client = new ApolloClient({
    uri: 'https://api.maganpenzugyiakademia.hu',
    cache: new InMemoryCache(),
    credentials: 'include',
});

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
const getMyUpsellListContacts = (id: number) => client.query<{ myUpsellListContacts: UpsellListContact[] }>({ query: myUpsellListContacts, variables: { upsellList: id }, fetchPolicy: 'network-only', errorPolicy: 'all' });

export default getMyUpsellListContacts;
